import styled from 'styled-components';

export const StyledImage = styled.img`
    max-width: unset;
    mix-blend-mode: multiply;
    max-height: 80px;
    margin: auto;
    max-width: 165px;
`;
